const Award = {
  parts: [
    'container',
    'contentWrapper',
    'imageSection',
    'image',
    'textSection',
    'title',
    'descriptionWrapper',
    'description'
  ],
  baseStyle: {
    container: {
      bg: 'brandColors.secondaryBG',
      width: 'full',
      overflow: 'hidden',
    },
    contentWrapper: {
      maxWidth: '1440px',
      mx: 'auto',
      display: 'flex',
      py: {base: 14, md: 20},
      px: {base: 5, md: 20},
      alignItems: 'flex-start',
      gap: {base: 10, md: 10},
      flexDirection: {base: 'column', md: 'row'},
    },
    imageSection: {
      display: 'flex',
      maxWidth: {base: 'full', md: '50%'},
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: {base: 'flex-start', md: 'center'},
      gap: 2.5,
      flexShrink: 0,
      alignSelf: 'stretch',
      order: {base: 2, md: 1},
      flex: '0 0 50%',
      minHeight: {base: '212px', md: 'auto'},
    },
    image: {
      width: {base: '316px', md: '400px'},
      aspectRatio: {base: '316/119', md: '8/3'},
      objectFit: 'contain',
      flexShrink: 0,
      maxWidth: '100%',
    },
    textSection: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 4, md: 10},
      flex: '1 0 0',
      order: {base: 1, md: 2},
    },
    title: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: {base: '28px', md: '40px'},
      fontWeight: 'medium',
      lineHeight: '120%',
      letterSpacing: {base: '-0.28px', md: '-0.4px'},
      mb: 0,
    },
    descriptionWrapper: {
      display: 'flex',
      pt: {base: 0, md: 2},
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: 6,
      alignSelf: 'stretch',
    },
    description: {
      alignSelf: 'stretch',
      color: 'brandColors.greyscale90',
      fontFamily: 'body',
      fontSize: {base: 'md', md: 'lg'},
      fontWeight: 'normal',
      lineHeight: '160%',
    },
  },
};

export default Award;
